import React from 'react';
import { Popup, Icon } from 'semantic-ui-react';
import { getLanguage } from '../../../../../i18n';
import { RightUserAPIResponse } from '../../../../../model/right/right.model';

/**
 * Get roles names decriptions
 * @param array roles = [{
 *  name,
 *  internationalizedNames: [de: , en: ,...],
 *  internationalizedDescriptions: [de: , en: ,...],
 *  rights: []
 * }]
 * @return array userRoles = [{ id, string name, popup description }]
 */
const getRolesNamesDescriptions = (roles: RightUserAPIResponse[]) => {
  if (!roles || roles.length === 0) {
    return [];
  }

  const userRoles = roles.map((r) => {
    const roleName =
      r.internationalizedNames && r.internationalizedNames[getLanguage()]
        ? r.internationalizedNames[getLanguage()]
        : r.name;
    const roleDescription =
      r.internationalizedDescriptions &&
      r.internationalizedDescriptions[getLanguage()]
        ? r.internationalizedDescriptions[getLanguage()]
        : null;
    return {
      id: r.id,
      name: roleName,
      description: !roleDescription ? null : (
        <Popup
          content={roleDescription}
          basic
          on="hover"
          trigger={<Icon link name="question circle" />}
        />
      ),
    };
  });
  return userRoles;
};

export default getRolesNamesDescriptions;
